function Equipamentos() {
    return (
        <section id="equipamentos" className="equipments">
            <div className="container">
                <h2>Equipamentos Disponíveis para Locação</h2>
                <div className="equip-slider">
                    <button className="arrow left" id="equipPrev"><i className="fas fa-chevron-left"></i></button>
                    <div className="equip-cards" id="equipCards">
                    <div className="equip-card"><img src="images/post1.png" alt="Post 01" /></div>
                    <div className="equip-card"><img src="images/post2.png" alt="Post 02" /></div>
                    <div className="equip-card"><img src="images/post3.png" alt="Post 03" /></div>
                    <div className="equip-card"><img src="images/post4.png" alt="Post 04" /></div>
                    <div className="equip-card"><img src="images/post5.jpg" alt="Post 05" /></div>
                    </div>
                    <button className="arrow right" id="equipNext"><i className="fas fa-chevron-right"></i></button>
                </div>
            </div>
        </section>
    );
}

export default Equipamentos;
